export const HeaderData = [
  {
    menu: "Home",
    link: "/",
  },

  {
    menu: "Why We Exist",
    link: "/why-we-exist",
  },

  {
    menu: "Join The Mission",
    link: "/#",
    submenu: true,
    subMenuitem: [
      {
        subItem: "Volunteer",
        linkL: "volunteer",
      },

      {
        subItem: "Partner",
        linkL: "partner",
      },
      {
        subItem: "Donate",
        linkL: "/make-donation",
      },
    ],
  },
  {
    menu: "Meet Our Team",
    link: "/team",
  },
  {
    menu: "Gallery",
    link: "/gallery",
  },
  //  {
  //     menu:"Events",
  //     link:"/#",
  //     submenu:true,
  //   subMenuitem:[
  //      {
  //          subItem:"Events",
  //          linkL:"/event",
  //      },

  //      {
  //          subItem:"Events Details",
  //          linkL:"/event-details",
  //      },
  //     ]
  //  },
  //  {
  //     menu:"Gallery",
  //     link:"/gallery",
  //  },
  //  {
  //     menu:"News",
  //     link:"/#",
  //     submenu:true,
  //   subMenuitem:[
  //      {
  //          subItem:"News",
  //          linkL:"/news",
  //      },

  //      {
  //          subItem:"News Details",
  //          linkL:"/news-details",
  //      },
  //     ]
  //  },
  //  {
  //     menu:"Pages",
  //     link:"/#",
  //     submenu:true,
  //   subMenuitem:[
  //      {
  //          subItem:" About",
  //          linkL:"/about",
  //      },

  //      {
  //          subItem:"Make Donation",
  //          linkL:"/make-donation",
  //      },
  //      {
  //          subItem:"Testimonials",
  //          linkL:"/testimonial",
  //      },
  //      {
  //          subItem:"Volunter",
  //          linkL:"/team",
  //      },
  //      {
  //          subItem:"Login",
  //          linkL:"/login",
  //      },
  //      {
  //          subItem:"Register",
  //          linkL:"/register",
  //      },
  //      {
  //          subItem:"FAQ",
  //          linkL:"/faqs",
  //      },
  //      {
  //          subItem:"Privacy Policy",
  //          linkL:"/privacy-policy",
  //      },
  //      {
  //          subItem:"Terms Service",
  //          linkL:"/terms-service",
  //      },
  //      {
  //          subItem:"404 Error",
  //          linkL:"*",
  //      },
  //     ]
  //  },

  {
    menu: "Contact Us",
    link: "/contact",
  },
];
